import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetSENTypes = () => {
    const {
        isFetching: isLoading, data: senTypes, error,
    } = useQuery({
        queryKey: ["SENTypes"],
        queryFn: () => axiosManager.get$("/parent/api/SENTypes").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const senTypesOptions = (senTypes || []).map((item) => ({ value: item.senTypeId, label: item.name }));

    return {
        isLoading, senTypes, error, senTypesOptions,
    };
};
